import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule, Routes } from '@angular/router';
import { ScrollToFragmentDirectiveModule } from '@commons/directives/scroll-to-fragment/scroll-to-fragment.directive';
import { MajorPartnersModule } from '@domains/home/major-partners/major-partners.component';
import { HomeBCompaniesModule } from '@features/homeB/companies/companies.component';
import { HomeBEmployerEngagementModule } from '@features/homeB/home-b-employer-engagement/home-b-employer-engagement.component';
import { HomeBEmployerModule } from '@features/homeB/home-b-employer/home-b-employer.component';
import { HomeBSectionModule } from '@features/homeB/home-b-section/home-b-section.component';
import { HomeBComponent } from '@features/homeB/home-b/home-b.component';
import { HomeBHeroModule } from '@features/homeB/home-hero/home-b-hero.component';
import { NavbarSectionHomeBModule } from '@features/homeB/navbar-section-home-b/navbar-section-home-b.component';
import { HomeBNewsListModule } from '@features/homeB/news-list/news-list.component';

const routes: Routes = [
  {
    path: '',
    component: HomeBComponent,
    data: {
      hideHeaderBorder: true,
      headerBgColor: '#526ab6',
    },
  },
];

@NgModule({
  declarations: [HomeBComponent],
  imports: [
    CommonModule,
    HomeBCompaniesModule,
    HomeBEmployerEngagementModule,
    HomeBEmployerModule,
    HomeBHeroModule,
    HomeBNewsListModule,
    HomeBNewsListModule,
    HomeBSectionModule,
    HomeBHeroModule,
    HomeBCompaniesModule,
    MatIconModule,
    NavbarSectionHomeBModule,
    RouterModule.forChild(routes),
    ScrollToFragmentDirectiveModule,
    MajorPartnersModule,
  ],
})
export class HomeBModule {}
